<!-- I2g Money -->
<div *ngIf="showI2gMoney" class="payment-method i2g-money">
  <div class="payment-option-field">
    <ng-container
      *ngIf="
        i2gMoneyContext?.application?.status !==
          i2gMoneyApplicationStatusEnum.denied;
        else i2gMoneyDenied
      "
    >
      <i2g-checkbox-field
        fieldId="i2g_money_enabled_field"
        [label]="'PAYMENTS.I2G_MONEY.LABEL' | translate"
        [fieldControl]="_i2gMoneyEnabledField"
        [trackingObject]="trackingObject"
        [trackingIdentifier]="i2gMoneyTrackingIdentifier"
        [trackingScreenName]="trackingScreenName"
        [trackingAdditionalProperties]="paymentOptionsTrackingProperties"
        (clickCheckbox)="
          this.i2gMoneyIsDisabled
            ? openI2gMoneyOnboardingDialog()
            : toggleI2gMoney($event)
        "
      >
      </i2g-checkbox-field>

      <div class="payment-method-side-icons">
        <app-icon
          class="info-icon"
          [icon]="infoIcon"
          trackable
          [trackingObject]="trackingObject"
          [trackingAction]="i2gMoneyInfoAction"
          (click)="openI2gMoneyOnboardingDialog()"
        >
        </app-icon>
      </div>
    </ng-container>

    <ng-template #i2gMoneyDenied>
      <div class="warning-action-container">
        <i2g-icon name="i2g-note-alert" size="medium"></i2g-icon>

        <div class="denied-message">
          <p class="title">{{ 'PAYMENTS.I2G_MONEY.LABEL' | translate }}</p>

          <div class="status-container">
            <p class="status">
              {{ 'PAYMENTS.I2G_MONEY.STATUS.DECLINED' | translate }}.
            </p>
            <button
              class="warning-action"
              (click)="openI2gMoneyOnboardingDialog()"
            >
              {{ 'LABEL.LEARN_MORE' | translate }}
            </button>
          </div>
        </div>
      </div>
    </ng-template>
  </div>
</div>

<!-- Stripe ACH Bank Transfer -->
<div
  *ngIf="showBankTransfer && !showI2gMoney"
  class="payment-method bank-transfer"
>
  <div class="payment-option-field">
    <i2g-checkbox-field
      fieldId="bank_transfer_enabled_field"
      [label]="'PAYMENTS.BANK_TRANSFER.LABEL' | translate"
      [fieldControl]="form.get(formKeys.BANK_TRANSFER_ENABLED)"
      [trackingObject]="trackingObject"
      [trackingIdentifier]="bankTransferTrackingIdentifier"
      [trackingScreenName]="trackingScreenName"
      [trackingAdditionalProperties]="paymentOptionsTrackingProperties"
      (clickCheckbox)="toggleBankTransfer($event)"
    >
    </i2g-checkbox-field>

    <div class="payment-method-side-icons">
      <app-icon
        class="info-icon"
        [icon]="infoIcon"
        trackable
        [trackingObject]="trackingObject"
        [trackingAction]="bankTransferInfoAction"
        (click)="openBankTransferInfoDialog()"
      >
      </app-icon>
    </div>

    <span class="new-flag">
      {{ 'BADGE.NEW' | translate }}
    </span>
  </div>
</div>

<!-- Card Payments -->
<div *ngIf="showCardPayments" class="payment-method card-payments">
  <div
    *ngIf="
      preventDisableOptions && cardPaymentsEnabled;
      else cardPaymentsCheckbox
    "
    class="no-disable"
  >
    <app-checkmark
      class="checkmark-icon"
      [iconSize]="IconSizesEnum.custom"
    ></app-checkmark>

    <p class="label">{{ 'PAYMENTS.STRIPE.LABEL' | translate }}</p>
  </div>

  <ng-template #cardPaymentsCheckbox>
    <i2g-checkbox-field
      class="card-payments-checkbox"
      fieldId="card_payments_enabled_field"
      [label]="'PAYMENTS.STRIPE.LABEL' | translate"
      [fieldControl]="form.get(formKeys.CARD_PAYMENTS_ENABLED)"
      [trackingObject]="trackingObject"
      [trackingIdentifier]="cardPaymentsTrackingIdentifier"
      [trackingScreenName]="trackingScreenName"
      [trackingAdditionalProperties]="paymentOptionsTrackingProperties"
      (clickCheckbox)="
        (!preventDisableOptions || !cardPaymentsEnabled) &&
          toggleCardPayments($event)
      "
    >
    </i2g-checkbox-field>
  </ng-template>

  <div class="payment-method-side-icons">
    <app-credit-cards
      class="credit-card-logos"
      [cards]="availableCardTypes"
      [ngClass]="{
        'prevent-disable': preventDisableOptions && cardPaymentsEnabled
      }"
      (click)="
        (!preventDisableOptions || !cardPaymentsEnabled) &&
          toggleCardPayments($event)
      "
    >
    </app-credit-cards>

    <app-icon
      class="info-icon"
      [class.alert]="!(isAccountVerified$ | async)"
      [icon]="infoIcon"
      trackable
      [trackingObject]="trackingObject"
      [trackingAction]="cardPaymentsInfoAction"
      (click)="openCardPaymentsInfoDialog()"
    >
    </app-icon>
  </div>
</div>

<div *ngIf="!(isAccountVerified$ | async)" class="disabled-stripe">
  {{ 'VERIFY_ACCOUNT.STRIPE_NOT_AVAILABLE' | translate }}
  <span class="resend-email" (click)="onResendEmail()">
    {{ 'DIALOG.PAYMENTS.LABEL.RESEND_EMAIL' | translate }}
  </span>
</div>

<!-- Paypal -->
<div *ngIf="showPaypalEc" class="payment-method paypal">
  <div class="payment-option-field">
    <div
      *ngIf="isPayPalToggleDisabled; else paypalEcCheckbox"
      class="no-disable"
    >
      <app-checkmark
        class="checkmark-icon"
        [iconSize]="IconSizesEnum.custom"
      ></app-checkmark>

      <p class="label">{{ 'PAYMENTS.PAYPAL.LABEL' | translate }}</p>
    </div>

    <ng-template #paypalEcCheckbox>
      <!-- Show toggle for new users and completed users -->
      <i2g-checkbox-field
        *ngIf="!paypalEcStatus || showPayPalToggle; else paypalPendingState"
        fieldId="paypal_ec_enabled_field"
        [label]="'PAYMENTS.PAYPAL.LABEL' | translate"
        [fieldControl]="form.get(formKeys.PAYPAL_EC_ENABLED)"
        [trackingObject]="trackingObject"
        [trackingIdentifier]="paypalTrackingIdentifier"
        [trackingScreenName]="trackingScreenName"
        [trackingAdditionalProperties]="paymentOptionsTrackingProperties"
        (clickCheckbox)="
          (!preventDisableOptions || !paypalEcEnabled) && togglePaypal($event)
        "
      >
      </i2g-checkbox-field>

      <ng-template #paypalPendingState>
        <div class="warning-action-container">
          <i2g-icon name="i2g-note-alert" size="medium"></i2g-icon>

          <div class="denied-message">
            <p class="title">{{ 'PAYMENTS.PAYPAL.LABEL' | translate }}</p>

            <div class="status-container">
              <p class="status">
                {{
                  'PAYMENTS.PAYPAL.STATUS.' + paypalEcStatus
                    | uppercase
                    | translate
                }}.
              </p>

              <button
                class="warning-action"
                i2gTrackable
                [trackingObject]="trackingObject"
                [trackingAction]="payPalWarningTrackingAction"
                (click)="onPayPalWarningAction()"
              >
                {{
                  'PAYMENTS.PAYPAL.ACTIONS.' + paypalEcStatus
                    | uppercase
                    | translate
                }}
              </button>
            </div>
          </div>
        </div>
      </ng-template>
    </ng-template>

    <div
      *ngIf="!paypalEcStatus || showPayPalToggle || isPayPalToggleDisabled"
      class="payment-method-side-icons"
    >
      <app-credit-cards
        class="paypal-logos"
        [cards]="availablePaypalLogos"
        [ngClass]="{
          'prevent-disable': preventDisableOptions && paypalEcEnabled
        }"
        (click)="
          (!preventDisableOptions || !paypalEcEnabled) && togglePaypal($event)
        "
      >
      </app-credit-cards>

      <app-icon
        *ngIf="infoIcon"
        class="info-icon"
        [icon]="infoIcon"
        trackable
        [trackingObject]="trackingObject"
        [trackingAction]="paypalInfoAction"
        (click)="openPaypalInfoDialog()"
      >
      </app-icon>
    </div>
  </div>
</div>

<ng-container *ngIf="showBankTransfer || showCardPayments || showPaypalEc">
  <app-setup-bank-transfer-dialog
    [achDebit]="achDebit"
    [locale]="locale"
    [underwritingUrl]="underwritingUrl"
    [trackingScreenName]="trackingScreenName"
    canvasIdentifier="stripe_setup"
    (onConfirm)="confirmSetupBankTransferDialog.emit()"
  >
  </app-setup-bank-transfer-dialog>

  <app-onboarding-stripe-dialog
    *ngIf="isAccountVerified$ | async"
    [underwritingUrl]="underwritingUrl"
    [trackingScreenName]="trackingScreenName"
  >
  </app-onboarding-stripe-dialog>

  <app-turn-on-payments-dialog
    [feesDescription]="cardFeesDescription"
    [trackingScreenName]="trackingScreenName"
    (onTurnOnPayments)="turnOnPayments()"
  >
  </app-turn-on-payments-dialog>
</ng-container>

<app-bank-transfer-info-dialog
  *ngIf="showBankTransfer"
  [achDebit]="achDebit"
  [locale]="locale"
>
</app-bank-transfer-info-dialog>

<app-card-payments-info-dialog
  *ngIf="showCardPayments && (isAccountVerified$ | async)"
  [description]="cardFeesDescription"
>
</app-card-payments-info-dialog>

<app-enable-stripe-verification-dialog
  *ngIf="!(isAccountVerified$ | async)"
  [trackingScreenName]="trackingScreenName"
  [trackingObject]="trackingObject"
>
</app-enable-stripe-verification-dialog>

<app-paypal-info-dialog *ngIf="showPaypalEc" [country]="companyCountry">
</app-paypal-info-dialog>

<!-- These are dialogs to check whether user wants to enable/disable
the payment method at invoice-level or account-level -->
<app-toggle-payment-method-dialog
  [dialogType]="toggleI2gMoneyDialogType"
  [text]="'DIALOG.TOGGLE_PAYMENTS.I2G.DESCRIPTION' | translate"
  [primaryActionText]="'DIALOG.TOGGLE_PAYMENTS.I2G.ACTIONS.PRIMARY' | translate"
  [secondaryActionText]="
    isDocumentAnEstimate
      ? ('DIALOG.TOGGLE_PAYMENTS.I2G.ACTIONS.SECONDARY_ESTIMATE' | translate)
      : ('DIALOG.TOGGLE_PAYMENTS.I2G.ACTIONS.SECONDARY_INVOICE' | translate)
  "
  [trackingScreenName]="trackingScreenName"
  [trackingDialogName]="trackingDialogName"
  [primaryActionTapped]="toggleI2gMoneyPrimaryAction"
  [secondaryActionTapped]="toggleI2gMoneySecondaryAction"
  (primaryAction)="toggleI2gMoneyFor(true)"
  (secondaryAction)="toggleI2gMoneyFor(false)"
>
</app-toggle-payment-method-dialog>

<app-toggle-payment-method-dialog
  [dialogType]="toggleCardPaymentsDialogType"
  [text]="'DIALOG.TOGGLE_PAYMENTS.STRIPE.DESCRIPTION' | translate"
  [primaryActionText]="
    'DIALOG.TOGGLE_PAYMENTS.STRIPE.ACTIONS.PRIMARY' | translate
  "
  [secondaryActionText]="
    isDocumentAnEstimate
      ? ('DIALOG.TOGGLE_PAYMENTS.STRIPE.ACTIONS.SECONDARY_ESTIMATE' | translate)
      : ('DIALOG.TOGGLE_PAYMENTS.STRIPE.ACTIONS.SECONDARY_INVOICE' | translate)
  "
  [trackingScreenName]="trackingScreenName"
  [trackingDialogName]="trackingDialogName"
  [primaryActionTapped]="toggleStripePrimaryAction"
  [secondaryActionTapped]="toggleStripeSecondaryAction"
  (primaryAction)="toggleCardPaymentsFor(true)"
  (secondaryAction)="toggleCardPaymentsFor(false)"
>
</app-toggle-payment-method-dialog>

<app-toggle-payment-method-dialog
  [dialogType]="togglePayPalDialogType"
  [text]="'DIALOG.TOGGLE_PAYMENTS.PAYPAL.DESCRIPTION' | translate"
  [primaryActionText]="
    'DIALOG.TOGGLE_PAYMENTS.PAYPAL.ACTIONS.PRIMARY' | translate
  "
  [secondaryActionText]="
    isDocumentAnEstimate
      ? ('DIALOG.TOGGLE_PAYMENTS.PAYPAL.ACTIONS.SECONDARY_ESTIMATE' | translate)
      : ('DIALOG.TOGGLE_PAYMENTS.PAYPAL.ACTIONS.SECONDARY_INVOICE' | translate)
  "
  [trackingScreenName]="trackingScreenName"
  [trackingDialogName]="trackingDialogName"
  [primaryActionTapped]="togglePaypalPrimaryAction"
  [secondaryActionTapped]="togglePaypalSecondaryAction"
  (primaryAction)="togglePayPalFor(true)"
  (secondaryAction)="togglePayPalFor(false)"
>
</app-toggle-payment-method-dialog>

<app-toggle-payment-method-dialog
  [dialogType]="toggleDirectTransferDialogType"
  [text]="'DIALOG.TOGGLE_PAYMENTS.DIRECT_TRANSFER.DESCRIPTION' | translate"
  [primaryActionText]="
    'DIALOG.TOGGLE_PAYMENTS.DIRECT_TRANSFER.ACTIONS.PRIMARY' | translate
  "
  [secondaryActionText]="
    isDocumentAnEstimate
      ? ('DIALOG.TOGGLE_PAYMENTS.DIRECT_TRANSFER.ACTIONS.SECONDARY_ESTIMATE'
        | translate)
      : ('DIALOG.TOGGLE_PAYMENTS.DIRECT_TRANSFER.ACTIONS.SECONDARY_INVOICE'
        | translate)
  "
  [trackingScreenName]="trackingScreenName"
  [trackingDialogName]="trackingDialogName"
  [primaryActionTapped]="toggleDirectTransferPrimaryAction"
  [secondaryActionTapped]="toggleDirectTransferSecondaryAction"
  (primaryAction)="toggleDirectTransferFor(true)"
  (secondaryAction)="toggleDirectTransferFor(false)"
>
</app-toggle-payment-method-dialog>
